import React,{Component} from "react"
import {NavBar,Tabs} from 'antd-mobile';
import AllOrder from '../AllOrder';
import Routing from '../Routing';
import Completed from '../Completed';
import RunOrder from '../RunOrder';
import GoodsOrder from '../GoodsOrder';
import './style.less';
export default class MyOrder extends Component{
    constructor(props) {
        super(props);
        this.state={
            tabs : [
                { title:"预约出行"},
                { title: "专车预约" },
                { title: "市内约车" },
                { title: "接送站" },
                { title: "带货" },
              ]
        }
    }

    componentDidMount() {}

   goPage(){
       this.props.history.goBack()
       this.props.history.go(-2)
   }
    render() {
        return (
            <div className="myOrder">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() =>this.props.history.goBack()}/>}
                >
                    行程
                </NavBar>
                    <Tabs prerenderingSiblingsNumber={false} tabs={this.state.tabs} swipeable={false}>
                        <AllOrder {...this.props}/>
                        <Routing  {...this.props}/>
                        <Completed {...this.props}/>
                        <RunOrder {...this.props}/>
                        <GoodsOrder {...this.props}/>
                    </Tabs>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/MyOrder/index.js